module.exports = __webpack_public_path__ + "img/Hypoxia-CRC_10X_TGSP.a1fd01a2.png";